import { render } from "./planShop.vue?vue&type=template&id=f9f0e2d0&scoped=true"
import script from "./planShop.vue?vue&type=script&lang=js"
export * from "./planShop.vue?vue&type=script&lang=js"

import "./planShop.vue?vue&type=style&index=0&id=f9f0e2d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f0e2d0"]])

export default __exports__